module.exports = "<template> <div class=tyl-popup part=root> <slot></slot> </div> </template>";